import { getAgencyApiHost, getApiHost } from '../api/host-by-env';
import { setupTelemetry } from './otel/setupTelemetry';

/**
 * Bootstrap OpenTelemetry before ReactDOM.render(). Must run once, before the app mounts.
 * Builds the CORS allowlist from runtime API host resolvers and wires up instrumentation.
 */
export function bootstrapTelemetry(): void {
  try {
    const corsUrls = [toOriginPattern(getApiHost()), toOriginPattern(getAgencyApiHost())].filter(Boolean);
    setupTelemetry(corsUrls);
  } catch {
    // Telemetry must never break the app
  }
}

function toOriginPattern(url: string): RegExp {
  const { origin } = new URL(url);
  const escaped = origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`^${escaped}(?=$|[/?#])`);
}
